<template>
  <div class="page" id="Zoom">
    <h1>Zoom</h1>
  </div>
</template>

<script>
export default {
  name: "Zoom"
}
</script>

<style scoped>

</style>
